import {ChangeDetectorRef, Component} from '@angular/core';
import {
  AlertController, App, IonicPage, LoadingController, MenuController, NavController, NavParams, Platform,
  ToastController, ViewController
} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";
import { Storage } from '@ionic/storage';


@Component({
  selector: 'page-list-data-model',
  templateUrl: 'list-data-model.html',
})
export class ListDataModelPage {

  Data:any;
  title:any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public service: ServiceProvider, public platform:Platform, menuCtrl:MenuController, public loadingCtrl: LoadingController, public toastCtrl: ToastController,
              public storage: Storage,
              public _app: App,
              public alertCtrl: AlertController,
              public cdRef:ChangeDetectorRef,
              public viewCtrl: ViewController) {
    this.platform.ready().then(() => {
      this.Data=navParams.get('data');
      this.title=navParams.get('title');

    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ListDataModelPage');
  }

  dismiss(){
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/list-data-model/list-data-model.ts